export const FEEDBACK_GET_MULTIPLE =  "FEEDBACK_GET_MULTIPLE"
export const FEEDBACK_GET_DROPDOWNS =  "FEEDBACK_GET_DROPDOWNS"
export const FEEDBACK_GET_ONE =  "FEEDBACK_GET_ONE"
export const FEEDBACK_REGISTER_SUCCESS =  "FEEDBACK_REGISTER_SUCCESS"
export const FEEDBACK_REGISTER_FAIL =  "FEEDBACK_REGISTER_FAIL"
export const FEEDBACK_LOADING =  "FEEDBACK_LOADING"
export const FEEDBACK_LOADING_ERROR =  "FEEDBACK_LOADING_ERROR"
export const FEEDBACK_ACTIVATE_FAIL =  "FEEDBACK_ACTIVATE_FAIL"
export const FEEDBACK_ACTIVATE_SUCCESS =  "FEEDBACK_ACTIVATE_SUCCESS"
export const FEEDBACK_UPDATE_SUCCESS =  "FEEDBACK_UPDATE_SUCCESS"
export const FEEDBACK_UPDATE_FAIL =  "FEEDBACK_UPDATE_FAIL"
export const FEEDBACK_DELETE_SUCCESS =  "FEEDBACK_DELETE_SUCCESS"
export const FEEDBACK_DELETE_FAIL =  "FEEDBACK_DELETE_FAIL"
export const FEEDBACK_EDIT =  "FEEDBACK_EDIT"